import React from 'react';

import DetailBookingListView from '../../../presentational/booking/bookingList/DetailBookingListView';
import DetailBookingListCancelView from '../../../presentational/booking/bookingList/DetailBookingListCancelView';
const DetailBookingList = (props) => {
    const { isCancelled, data, onClickClose } = props;

    if (isCancelled) {
        return (
            <DetailBookingListCancelView
                isCancelled={isCancelled}
                data={data}
                onClickClose={onClickClose}
            />
        );
    } else {
        return (
            <DetailBookingListView
                isCancelled={isCancelled}
                data={data}
                onClickClose={onClickClose}
            />
        );
    }
};

export default DetailBookingList;
